<script>
export default {
  methods: {
    playButtonSound: function() {
      if(this.playSounds) {
        (new Audio('sounds/button-up-high.wav')).play();
      }
    }
  }
}
</script>

